import React from 'react';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { HtmlTable } from '../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { WorkflowComponentProps } from '../../Workflow/Workflow.meta';

interface Props {
  workflowProps?: WorkflowComponentProps;
}

export const StockOptionsEmpty = ({ workflowProps }: Props) => {
  return (
    <HtmlTable variant={workflowProps && 'bordered'}>
      <Box p="16">
        <Text variant="cardTitle" color="neutral.700" pb="16">
          Stock Options / Restricted Stock
        </Text>

        <Text fontWeight={500} color="neutral.500">
          You have not added any items.
        </Text>
      </Box>
    </HtmlTable>
  );
};
